import { Participant } from 'twilio-video'

import { useAudioTrack } from './tracks/use_audio_track'

export const ParticipantAudio = ({
  participant,
}: {
  participant: Participant
}) => {
  useAudioTrack(participant, true)

  return null
}
